import { render, staticRenderFns } from "./PointsLogs.vue?vue&type=template&id=6964b5ec"
import script from "./PointsLogs.vue?vue&type=script&lang=js"
export * from "./PointsLogs.vue?vue&type=script&lang=js"
import style0 from "./PointsLogs.vue?vue&type=style&index=0&id=6964b5ec&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6964b5ec')) {
      api.createRecord('6964b5ec', component.options)
    } else {
      api.reload('6964b5ec', component.options)
    }
    module.hot.accept("./PointsLogs.vue?vue&type=template&id=6964b5ec", function () {
      api.rerender('6964b5ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PointsLogs.vue"
export default component.exports